<template>
  <div class="message-center">
    <div class="query-form">
       <a-row type="flex" style="width: 100%;">
        <a-col :sm="24" :md="24" :lg="18" :xl="18">
          <div class="search-keyword">
              <a-input placeholder="请输入资讯标题进行搜索" allowClear v-model="blurry" style="margin: 0 20px;" @pressEnter="blurrySearch"></a-input>
              <a-button type="primary" icon="search"  @click="blurrySearch">搜索</a-button>
          </div>
         </a-col>
        <a-col :sm="24" :md="24" :lg="6" :xl="6">
          <a-button type="primary" style="float:right;margin: 8px 20px  8px 0;" icon="plus" @click="openAdd">添加</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :dataSource="newsList"
        :pagination="pagination"
        :rowKey="r => r.id"
        :loading="loading"
        @expandRowByClick="true"
        @change="tableChange">
        <template slot="imageUrl" slot-scope="record">
          <img @click="preview(record.imageUrl)" style="width: 100px; height: 50px;cursor: pointer" :src="record.imageUrl" alt="">
        </template>
        <template slot="isTop" slot-scope="record">
          <p v-if="record.isTop">是</p>
          <p v-else>否</p>
        </template>
        <template slot="publishTime" slot-scope="record">
          <p v-if="record.publishTime">{{record.publishTimeString}}</p>
          <p v-else>-</p>
        </template>
        <template slot="ispublish" slot-scope="record">
          <p v-if="record.ispublish">已发布</p>
          <p v-else>草稿</p>
        </template>
        <template slot="operation"  slot-scope="record">
          <a-button size="small" type="primary" v-if="!record.ispublish" @click="pushAction(record.id)">发布</a-button>
          <a-button size="small" type="primary" v-if="!record.ispublish" @click="editAction(record)">修改</a-button>
          <a-button size="small" type="primary" v-if="record.ispublish" @click="cancelPushAction(record.id)">取消发布</a-button>
          <a-button size="small" type="danger" v-if="!record.ispublish" @click="delAction(record)">删除</a-button>
        </template>
      </a-table>
    </div>
    <AaddNews v-if="ifAddNews" :ifAdd="ifAdd" :editId="editId" :detailObj="detailObj" @hideAction="hideAction" @successAction="successAction"/>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import AaddNews from '@/components/users/message/AaddNews.vue'
import {formatDate, dateDiff} from '@/utils/date';
import { getNewsList, deleteNews, pushNews, cancelPushNews } from '@/api/news';
// import 
const align = 'center'
export default {
  components: {AaddNews},
  data() {
    return {
      ifAddNews: false,
      columns: [
        {
          title: "资讯标题",
          dataIndex: "title",
          align
        },
        {
          title: "资讯类别",
          dataIndex: "classify",
          align
        },
        {
          title: "封面图片",
          scopedSlots: { customRender: 'imageUrl' },
          align
        },
        {
          title: "是否置顶",
          scopedSlots: { customRender: 'isTop' },
          align
        },
        {
          title: "发布时间",
          scopedSlots: { customRender: 'publishTime' },
          align
        },
        {
          title: "资讯来源",
          dataIndex: "newsFrom",
          align
        },
        {
          title: "发布状态",
          scopedSlots: { customRender: 'ispublish' },
          align
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'operation' },
          align,
          fixed: 'right',
        }
      ],
      loading: true,
      blurry: '',
      newsList: [],
      ifAdd: true,
      editId: null,
      detailObj: {},
      previewVisible: false,
      previewImage: '',
      pagination: {
        showSizeChanger:true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChange:(current, pageSize) => {
          this.pageSize = pageSize
        }
      },
    };
  },
  created() {
    this.getNewsList();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    }
  },
  methods: {
    preview(url){
        this.previewVisible = true;
        this.previewImage = url
    },
    handleCancel() {
      this.previewVisible = false;
    },
    getNewsList() {
        let params = {
          page: this.pagination.current,
          size: this.pagination.pageSize,
          blurry: this.blurry
        }
        getNewsList(params)
            .then(res => {
              setTimeout(() => {
                this.newsList = res.content;
                this.pagination.total = res.totalElements;
                this.loading = false;
              }, 500)
            })
            .catch(error => {
                console.log(error);
            })
    },
    openAdd(){
      this.$router.push({path: '/user/richText', query: {'isAdd': 'new', 'editId': null}});
    },
    editAction(record) {
      this.$router.push({path: '/user/richText', query: {'isAdd': 'old', 'editId': record.id}});
    },
    delAction(record) {
        let that = this;
        that.$confirm({
            title: '确定要删除吗！',
            okText: '确认',
            cancelText: '取消',
            onOk:function () {
                that.deleteNews(record.id);
            },
        })
    },
    pushAction(id) {
        let that = this;
        that.$confirm({
            title: '确定要发布吗！',
            okText: '确认',
            cancelText: '取消',
            onOk:function () {
                that.pushNews(id);
            },
        })
    },
    cancelPushAction(id) {
        let that = this;
        that.$confirm({
            title: '确定要取消发布吗！',
            okText: '确认',
            cancelText: '取消',
            onOk:function () {
                that.cancelPushNews(id);
            },
        })
    },
    deleteNews(id) {
      deleteNews(id)
        .then(res => {
          this.$message.success('删除成功');
          this.loading = true;
          this.getNewsList();
        })
        .catch(error => {
          console.log(error)
        })
    },
    pushNews(id) {
      pushNews(id)
        .then(res => {
          this.$message.success('发布成功');
          this.loading = true;
          this.getNewsList();
        })
        .catch(error => {
          console.log(error)
        })
    },
    cancelPushNews(id) {
      cancelPushNews(id)
        .then(res => {
          this.$message.success('已取消发布');
          this.loading = true;
          this.getNewsList();
        })
        .catch(error => {
          console.log(error)
        })
    },
    hideAction() {
      this.ifAddNews = false;
    },
    successAction() {
      this.ifAddNews = false;
      this.loading = true;
      this.getNewsList();
    },
    blurrySearch() {
      this.pagination.current = 1;
      this.loading = true;
      this.getNewsList();
    },
    tableChange(pagination,filters,sorter){
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.loading = true;
      this.getNewsList();
    }
  },
};
</script>

<style lang="less" scoped>
/deep/.ant-modal-close-x {
    width: 30px;
    height: 30px;
    line-height: 30px;
    .anticon-close {
        font-size: 20px;
    }
}
.message-center {
  height: 100%;
  // background-color: #fff;
  .query-form {
    padding: 16px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .icon-area {
        height: 40px;
        line-height: 80px;
    }
    .search-keyword {
      max-width: 800px;
      width: 57%;
      min-width: 400px;
      float: left;
      margin: 8px 20px  8px 0;
      display: flex;
      align-items: center;
      .ant-input {margin-right: 10px;}
      .gj-search {
      margin-left: 10px;
    }
    .reset-search {
      margin-left: 10px;
    }
    }
  }
  .table{
    background-color: #fff;
    .ant-btn {
      margin-right: 10px;
    }
  }
}
</style>
